import { useFieldArray, useFormContext } from "react-hook-form";
import { isConditionComplete } from "~/pages/security-model/RiskFactorsConfiguration/ConditionBuilder/ConditionRow/hooks/useRiskFactorsConditionRow";
import {
  getInitialCondition,
  RiskFactorsConfigurationInput,
} from "~/pages/security-model/RiskFactorsConfiguration/ConfigurationForm/RiskFactorsConfigurationForm";

export function useRiskFactorsConditionBuilder(fieldId: string) {
  const { control, watch } = useFormContext<RiskFactorsConfigurationInput>();

  const { fields, append, remove } =
    useFieldArray<RiskFactorsConfigurationInput>({
      control,
      name: `${fieldId}.selections`,
    });

  const handleAddNewSelection = () => {
    append({
      conditions: [getInitialCondition()],
    });
  };

  const selections = watch(`${fieldId}.selections`) || [];

  const handleRemoveSelection = (conditionIndex: number) =>
    remove(conditionIndex);

  return {
    canAddSelection: selections.every((selection) =>
      selection.conditions.every(isConditionComplete),
    ),
    handleAddNewSelection,
    handleRemoveSelection,
    fields,
  };
}
